import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import { getToken, getTokenExpiry, setTokenExpiry } from "@/utils/myAuth";

Vue.use(VueRouter);
let originPush = VueRouter.prototype.push;
let originReplace = VueRouter.prototype.replace;

VueRouter.prototype.push = function (location, resolve, reject) {
  if (resolve && reject) {
    originPush.call(
      this,
      location,
      () => {},
      () => {}
    );
  } else {
    originPush.call(
      this,
      location,
      () => {},
      () => {}
    );
  }
};
VueRouter.prototype.replace = function (location, resolve, reject) {
  if (resolve && reject) {
    originReplace.call(
      this,
      location,
      () => {},
      () => {}
    );
  } else {
    originReplace.call(
      this,
      location,
      () => {},
      () => {}
    );
  }
};


const router = new VueRouter({
  // mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  if (to.meta.permission) {
    const token = getToken();
    // const expiry = getTokenExpiry();
    const n = new Date().valueOf();
    // if (token && expiry > n) {
    if (token) {
      //setTokenExpiry(n+1800000)
      next();
    } else {
      router.push("/login?url=" + to.path);
    }
  } else {
    next();
  }
});

export default router;
